import React, { useState, useEffect } from "react";

const WelcomeMessage = ({ profile, msg }) => {
  const [displayMessage, setDisplayMessage] = useState(null);

  // Display message for 7 seconds
  useEffect(() => {
    if (msg) {
      setDisplayMessage(msg);
      const timer = setTimeout(() => {
        setDisplayMessage(null); // Hide the message after 7 seconds
      }, 7000);

      return () => clearTimeout(timer); // Clean up timeout on component unmount
    }
  }, [msg]); // Effect runs when `msg` changes

  const getTimeOfDay = () => {
    const hours = new Date().getHours();
    if (hours < 12) {
      return "Morning";
    } else if (hours < 18) {
      return "Afternoon";
    } else {
      return "Evening";
    }
  };

  return (
    <div>
      {/* Conditional message display */}
      {displayMessage && <div className="alert alert-info">{displayMessage}</div>}
      
      {/* Display the time of day greeting and name */}
      <h1>{getTimeOfDay()}, {profile.first_name}</h1>
      <p>{profile.email}</p>
    </div>
  );
};

export default WelcomeMessage;
